import { useStoreSelector } from '@hook/store/store.hooks';
import { isExist } from '@util/data/is-exist';

export const useDashboardStart = () => {
  const integrations = useStoreSelector((state) => state.integrations.data);
  const consumers = useStoreSelector((state) => state.consumers.data);

  if (isExist(Object.values(integrations).find((integration) => integration.isEnabled))) {
    if (Object.keys(consumers).length > 0) {
      return 3;
    }

    return 2;
  }

  return 1;
};
